import script from "./username.vue?vue&type=script&lang=js"
export * from "./username.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"resources/js/pages/components/form/input-only/username.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7d08b04b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7d08b04b', __exports__)) {
    console.log('reload')
    api.reload('7d08b04b', __exports__)
  }
  
}


export default __exports__